export const environment = {
  production: true,
  test: false
};
